"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketStatusType = exports.TicketRequestType = void 0;
var TicketRequestType;
(function (TicketRequestType) {
    TicketRequestType["WARRANTY"] = "Warranty";
    TicketRequestType["REFUND"] = "Refund";
    TicketRequestType["TEST_DRIVE"] = "Test Drive";
    TicketRequestType["CAR_VIEWING"] = "Car Viewing";
    TicketRequestType["COMPLAINT"] = "Complaint";
})(TicketRequestType = exports.TicketRequestType || (exports.TicketRequestType = {}));
var TicketStatusType;
(function (TicketStatusType) {
    TicketStatusType["OPEN"] = "Open";
    TicketStatusType["IN_PROGRESS"] = "In Progress";
    TicketStatusType["RESOLVED"] = "Resolved";
    TicketStatusType["CLOSED"] = "Closed";
})(TicketStatusType = exports.TicketStatusType || (exports.TicketStatusType = {}));
